namespace app.tarefas.details {
    "use strict";
    
    import ITranslatePartialLoaderProvider = ng.translate.ITranslatePartialLoaderProvider;
    import IStateProvider = ng.ui.IStateProvider;
    import AuthService = app.autenticacao.AuthService;
    import IRootScopeService = ng.IRootScopeService;
    import ITimeoutService = ng.ITimeoutService;
    import AuthorizationService = app.support.authorization.AuthorizationService;

    declare let angular: ng.IAngularStatic;

    /** @ngInject **/
    function config($translatePartialLoaderProvider: ITranslatePartialLoaderProvider,
                    $stateProvider: IStateProvider,
                    msNavigationServiceProvider: {}) {

        $translatePartialLoaderProvider.addPart("app/main/tarefas/details");

        $stateProvider.state('app.tarefas.details', {
            url: '/id/{context:any}/{id:any}',
            views: {
                "content@app.autenticado": {
                    templateUrl: "app/main/tarefas/details/tarefas-details.html",
                    controller: TarefasDetailsController,
                    controllerAs: "vm",
                    resolve: {
                        context:  /** @ngInject */ ($stateParams: ng.ui.IStateParamsService) => {
                                return $stateParams["context"];
                        },
                        id:  /** @ngInject */ ($stateParams: ng.ui.IStateParamsService) => {
                                return $stateParams["id"];
                        },
                    }
                }
            }
        });
    }
    
    /** @ngInject **/
    function run($rootScope: IRootScopeService, $timeout: ITimeoutService) {
        
    }

    angular
        .module("app.tarefas.details", ["app.tarefas"])
        .config(config)
        .run(run);
}
